<template>
  <!-- :closed="closed" -->
  <ExpandCard
    :opened="opened"
    :hasScrollIntoView="false"
    class="trainplan f-column"
    style="
      --max-height: var(--vh-3);
      --min-height: 4rem;
      --radius: 8px;
      --content-padding: 1rem 1.5rem;
      --title-padding: 0.5rem 0.75rem 0.5rem 1.25rem;
      --radius-conent: 0 0 8px 8px;
      --icon-opener-padding: 0.75rem;
    "
  >
    <template #title>
      <div class="trainplan_title">
        <Checkbox
          class="clr-grey mr-2 trainplan_title_checkbox"
          style="
            position: relative;
            --icon-size: 1.75rem;
            --c lr-disabled: var(--clr-grey-2);
            --clr-enabled: var(--clr-plan-primary);
          "
          :value="finished"
          :icons="['mdi-circle-outline', 'mdi-checkbox-marked-circle']"
          @click.stop="$emit('toggle:finished')"
        >
        </Checkbox>

        <div class="f-column mr-auto">
          <div class="clr-grey text-small">#{{ item.index + 1 }}</div>

          <div class="trainplan_title_text truncate">
            {{ item.step_title }}
          </div>
        </div>
        <div class="trainplan_title_spacer"></div>
        <div class="trainplan_title_icons">
          <div
            v-for="(icon, index) in getIcons(tasks)"
            :key="index"
            class="mdi trainplan_title_icons_item"
            :class="icon"
          ></div>
        </div>
      </div>
    </template>

    <div class="f-column">
      <div class="trainplan_description clr-grey">
        {{ item.step_description }}
      </div>

      <div class="trainplan_task_groups mr-auto">
        <a
          v-for="(task, index) in tasks"
          :key="index"
          :href="task.url"
          target="_blank"
          class="trainplan_task_groups_group gw_btn text-underlines text-underline_hovers"
          style="
            --height: 2.5rem;
            --padding: 0 1rem;
            --clr: var(--clr-primary);
            --brighten-hover: 0.0525;
          "
        >
          <div
            class="mdi text-large"
            :class="task.type.icon"
          ></div>
          <div class="ml-2 clr-white">
            {{ task.text }}
          </div>
          <div
            v-if="task.is_premium"
            class="gw_tag text-smallest"
            style="
              position: absolute;
              right: 0;
              top: -0.625rem;
              padding: 0.075em 0.25em;
              --clr-tag-back: var(--clr-primary);
            "
            v-html="$t('common.premium')"
          />

          <a
            v-if="task.url_master && notMaster"
            class="clr-error text-underline text-underline_hover"
            :href="task.url_master"
            target="_blank"
          >
            --test-drill-on-prod--
          </a>
        </a>
      </div>

      <div
        v-if="!finished"
        class="f-center clr-grey text-small ml-auto mt-2"
      >
        <div class="mdi mdi-information mr-1 text-medium"></div>
        {{ $t('study_plans.note_mark_as_finished') }}
      </div>
    </div>
  </ExpandCard>
</template>

<script>
import ExpandCard from '@/components/Common/ExpandCard/ExpandCard'
import Checkbox from '@/components/Common/Checkbox/Checkbox'
import ProgressCircle from '@/components/lib/ProgressCircle'
import format_mix from '@/mixins/format_mix'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'StudyPlanStep',
  components: {
    ExpandCard,
    Checkbox,
    // ProgressCircle,
  },
  mixins: [float_mix, format_mix],
  props: {
    item: {
      default: () => ({}),
    },
    opened: Boolean,
    finished: Boolean,
    notMaster: Boolean,
  },
  emits: ['toggle:finished'],
  data() {
    return {
      // title
      // description
      // article
      // video
      // tasks
      // drills
      // valueUnit: 20,
    }
  },
  mounted() {
    // setInterval(() => {
    //   this.valueUnit += 20
    // }, 500)
  },
  methods: {
    getIcons(tasks) {
      return [...new Set(tasks.map(i => i.type.icon))]
    },
  },
  computed: {
    tasks() {
      const { item } = this
      const types = {
        article: { id: 'article', icon: 'mdi-book' },
        video: { id: 'video', icon: 'mdi-play-circle' },
        drill: { id: 'drill', icon: 'mdi-google-controller' },
        study: { id: 'study', icon: 'mdi-school' },
        task: { id: 'task', icon: 'mdi-school' },
      }

      const max_tasks = [...new Array(20).keys()]
      const res = max_tasks
        .map((i, idx) => {
          const tt = item[`task_${idx}_type`]
          // console.log(tt)
          if (!tt) {
            return null
          }
          const type = types[tt.toLowerCase()]
          let url = item[`task_${idx}_url`]
          let url_master = null
          if (!type) {
            console.log(i, type)
            debugger
          }
          // console.log(type, idx)
          if (type.id === 'drill') {
            if (url.startsWith('{'))
              try {
                const exportedDrill = JSON.parse(url)
                const params = new URLSearchParams(exportedDrill.query)
                url = `${window.location.origin}/practice/trainer?${params}`
                url_master =
                  import.meta.env.VITE_BRANCH !== 'master'
                    ? `https://app.gtowizard.com/practice/trainer?${params}`
                    : null
                // console.log(exportedDrill)
                // console.log(params)
                // console.log(url)
              } catch (error) {
                console.log(this.item)
                console.warn(i)
                console.warn(error)
                // debugger
              }
            else {
              url_master = import.meta.env.VITE_BRANCH !== 'master' ? url : null
              url = url.replace('https://app.gtowizard.com', window.location.origin)
            }
          }
          const r = {
            id: `task_${idx}`,
            type,
            url,
            url_master,
            text: item[`task_${idx}_link_text`],
            is_premium: item[`task_${idx}_is_premium`],
          }
          // console.log(type)
          return r
        })
        .filter(i => i)
      // console.log(res, this.item)
      return res
    },
  },
}
</script>
<style lang="scss" scoped>
.trainplan {
  &_title {
    display: flex;
    align-items: center;
    justify-content: center;
    // position: relative;
    // gap: 0.75rem;
    gap: 0.5rem;
    width: 100%;
    &_checkbox {
    }
    &_progress {
      // margin: 0 1rem 0 0;
      // position: absolute !important;
    }
    &_text {
      font-size: 1.125rem;
      color: var(--clr-white-0);
      text-transform: none;
      font-weight: 500;
      max-width: calc(100vw - 8rem);
      // white-space: normal;
    }
    &_spacer {
      height: var(--min-height);
      width: 1px;
      position: absolute;
      top: 0;
      right: 4.5rem;
      background: var(--clr-black-2);
    }
    &_icons {
      position: absolute;
      right: 4rem;
      display: flex;
      align-items: center;
      gap: 0.5rem;
      margin: auto 3rem 0 auto;
      &_item {
        font-size: 2rem;
        // color: var(--clr-black-5);
      }
    }
  }
  &_task_groups {
    padding: 2rem 0 0 0;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    // a:visited {
    //   // color: var(--clr-primary-0);
    //   background: transparent;
    //   border: solid red !important;
    // }
    &_group {
      // display: flex;
      // align-items: center;
      justify-content: flex-start;
      // font-size: 1rem;
      // &:visited {
      //   border: red solid;
      // }
    }
  }
  &_tasks {
    &_item {
    }
  }
}
@media screen and (max-width: 500px) {
  .trainplan {
    &_title {
      &_icons {
        display: none;
      }
    }
  }
}
</style>
